import { Icon } from './Icon';

/** Завести новое: предмет, питомца, внешку, участника. */
export function PlusIcon({ size }: { size?: number }) {
  return (
    <Icon size={size}>
      <path d="M7 2.2 V11.8" />
      <path d="M2.2 7 H11.8" />
    </Icon>
  );
}
